import { Helmet } from "react-helmet-async";
import { filter } from "lodash";
import { sentenceCase } from "change-case";
import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Avatar,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
  Grid,
} from "@mui/material";
// components

import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";

import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
// ----------------------------------------------------------------------

export default function FixturesGoaliePage() {
  const navigate = useNavigate();
  const [rows, setRows] = useState(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/admin/fixtures-goalies`)
      .then(function (response) {
        const allFixtures = response.data.fixtures;

        setRows(allFixtures);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>Fixtures </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Fixtures
          </Typography>
        </Stack>

        <Card>
          {rows === null ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Match</TableCell>
                      <TableCell>Start EST</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          <Grid container>
                            <Grid item xs={12} sx={{ fontSize: 20 }}>
                              {row.home_team.name} vs {row.away_team.name}
                            </Grid>

                            {row.home_team_goalies &&
                              row.home_team_goalies.map((goalie, index) => (
                                <Grid item xs={12}>
                                  {goalie.fname + " " + goalie.lname} vs{" "}
                                  {row.away_team.name}
                                </Grid>
                              ))}
                            {row.away_team_goalies &&
                              row.away_team_goalies.map((goalie, index) => (
                                <Grid item xs={12}>
                                  {goalie.fname + " " + goalie.lname} vs{" "}
                                  {row.home_team.name}
                                </Grid>
                              ))}
                          </Grid>
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {new Date(row.start_utc).toLocaleString("en-US", {
                            timeZone: "America/Toronto",
                          })}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          )}
        </Card>
      </Container>
    </>
  );
}
